import React, { FC, useState } from 'react';

import { NamePath } from 'antd/es/form/interface';
import dayjs from 'dayjs';

import DatePickerFormItem from '@/components/form/form-items/default-items/date-picker-form-item/DatePickerFormItem';

import { DEFAULT_DATE_UAS_FORMAT_MOBILE } from '@/constants/defaultDateFormat';

import { CellData } from '../cell-data';

import { isNil } from '@/utils';

type TEditableInputFormItemProps = {
	name: NamePath;
	itemValue?: string | number;
};

export const EditableDateFromItem: FC<TEditableInputFormItemProps> = ({ name, itemValue }) => {
	const [editMode, setEditMode] = useState<boolean>(true);
	const [shouldAutofocus, setShouldAutofocus] = useState<boolean>(false);

	return editMode ? (
		<DatePickerFormItem
			datePickerProps={{
				placeholder: ' ',
				allowClear: false,
				format: DEFAULT_DATE_UAS_FORMAT_MOBILE,
				autoFocus: shouldAutofocus,
				open: shouldAutofocus ? true : undefined,
				onChange: () => {
					setEditMode(false);
					setShouldAutofocus(true);
				},
				onOpenChange: (open: boolean) => {
					if (open || !itemValue) return;

					setEditMode(false);
					setShouldAutofocus(true);
				},
			}}
			marginBottom={0}
			name={name}
			rules={[{ required: false }]}
		/>
	) : (
		<CellData onClick={() => setEditMode(true)}>
			{!isNil(itemValue) && dayjs(itemValue).isValid()
				? dayjs(itemValue).format(DEFAULT_DATE_UAS_FORMAT_MOBILE)
				: ''}
		</CellData>
	);
};
